<template>
  <div class="SubstitutionCar">
    <HeaderTop/>
    <div class="w">
      <div class="container">
        <div class="container-top">
          <div class="container-bg">
            <h3>以旧换新<em></em>诚信服务</h3>
          </div>
        </div>
        <div class="container-bottom">
          <el-form ref="form" :model="form" :rules="rules">
            <h4>— 您的爱车 —</h4>
            <p>
              <span><b>*</b>品牌车型：</span>
              <el-form-item prop="oldCarBrand">
                <el-input v-model="form.oldCarBrand" placeholder="请输入您的品牌车型" type="text" value="" ></el-input>
              </el-form-item>
            </p>
            <p>
              <span><b>*</b>首次上牌：</span>
              <el-form-item prop="firstRegister">
                <!-- <input v-model="form.firstRegister" placeholder="請輸入您的姓名" type="text" value="" /> -->
                <el-date-picker value-format="yyyy-MM-dd" v-model="form.firstRegister" type="date" placeholder="请选择上牌日期"></el-date-picker>
              </el-form-item>
            </p>
            <p><span><b>*</b>行驶里程：</span>
            <el-form-item prop="mileage">
              <el-input v-model="form.mileage" placeholder="请输入行驶公里" type="text" value="" ></el-input>
            </el-form-item>
            </p>

            <p>
              <span><b>*</b>上牌城市：</span>
              <el-form-item prop="city">
                <el-input v-model="form.city" placeholder="请输入上牌地点" type="text" value="" ></el-input>
              </el-form-item>
            </p>

            <h4>— 新车意向 —</h4>

            <p>
              <span><b>*</b>品牌车型：</span>
              <el-form-item prop="newCarBrand">
                <el-input v-model="form.newCarBrand" placeholder="请输入新车意向" type="text" value="" ></el-input>
              </el-form-item>
            </p>
            <h4>— 选择服务 —</h4>
            <p>
              <span><b>*</b>电话号码：</span>
              <el-form-item prop="phoneNo">
                <el-input v-model="form.phoneNo" placeholder="请输入您的电话号码" type="text" value="" ></el-input>
              </el-form-item>
            </p>
            <p>
              <span style="position: relative; top: -30px; left: -4px;"><b>*</b>选择服务：</span>
              <el-form-item>
                <el-checkbox-group v-model="form.service">
                  <el-checkbox @change="handleChecked" v-for="(item, index) in serviceType" :label="item.idType" :key="index" name="type">
                    {{item.nameType}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </p>
            <!-- <el-form-item><span class="cc"><b>*</b>选择服务：</span>
              <em><label><input type="checkbox" name="金融贷款服务(名车中心多种方案)" value="金融贷款服务(名车中心多种方案)" />金融贷款服务(名车中心多种方案)</label></em>
            </el-form-item> -->
            <el-form-item class="button">
              <input type="button" @click="onSubmit($event)" value="我要换车"/>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <FooterAbout/>
    </div>
    <Copy/>
  </div>
</template>

<script>
import { reqAddCarForChange } from '../api'
import HeaderTop from '../components/HeaderTop.vue'
import FooterAbout from '../components/FooterAbout.vue'
import Cookies from 'js-cookie'
import Copy from '../components/Copy.vue'

export default {
  name: 'SubstitutionCar',
  data () {
    return {
      serviceType:[
        {idType: 0, nameType: '名車中心幫您賣車（免費優質服務）'},
        {idType: 1, nameType: '金融貸款服務（名車中心多種方案）'}
      ],
      form: {
        oldCarBrand: '',
        firstRegister: '',
        mileage: '',
        city: '',
        newCarBrand: '',
        phoneNo: '',
        service: [],
        position: Cookies.get('position') || 2
      },
      rules:{
        oldCarBrand: [{ required: true, message: '请输入您的品牌车型', trigger: 'blur' }], 
        firstRegister: [{ required: true, message: '请选择上牌日期', trigger: 'blur' }], 
        mileage: [{ required: true, message: '请输入行驶公里', trigger: 'blur' }], 
        city: [{ required: true, message: '请输入上牌地点', trigger: 'blur' }], 
        newCarBrand: [{ required: true, message: '请输入新车意向', trigger: 'blur' }],  
        phoneNo: [{ required: true, message: '请输入您的电话号码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleChecked(val) {
      console.log('val', val)
    },
    onSubmit(event) {
      event.preventDefault()
      let formData = this.form
      formData.service = formData.service.join(';')
      console.log('formData', formData)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          reqAddCarForChange(formData).then( res => {
            if (res.status) {
              console.log('提交成功')
              this.$message({
                message: "提交成功！",
                customClass: 'mode',
                type: 'success'
              })
              console.log('reqAddCarForChange',formData)
              // this.$router.back(-1)
            } else {
              this.$message({
                message: "提交失败，请填写对应的内容！",
                customClass: 'mode',
                type: 'error'
              })
              this.$nextTick(() => {
                this.form.service = []
              })
              return false
            }
            this.$nextTick(() => {
              this.$refs.form.resetFields()
              this.form.oldCarBrand = ''
              this.form.firstRegister = ''
              this.form.mileage = ''
              this.form.city = ''
              this.form.newCarBrand = ''
              this.form.phoneNo = ''
              this.form.service = []
            })
          })
        } else {  
          this.$nextTick(() => {
            this.form.service = []
          })
          this.$message({
            message: "添加失败，请填写对应的内容！",
            customClass: 'mode',
            // duration: 300000,
            type: 'error'
          })
        }
      })
    }
  },
  components: {
    HeaderTop,
    FooterAbout,
    Copy
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>      

  .SubstitutionCar >>> .el-input--prefix .el-input__inner
    padding-left 0.5rem
  .SubstitutionCar >>> .el-form-item__content
    position static
    font-size 15px
    line-height normal
    .el-checkbox-group
      width 50%
      display inline-block
      text-align left
      .el-checkbox
        font-size 16px
        display block
        margin-bottom 5px
        .el-checkbox__input
          &.is-checked .el-checkbox__inner
            background-color #d81240
            border-color #d81240
            &::after
              width 0.10666rem
              height 0.213333rem
              top 0.013333rem
              left 0.088333rem
        span
          color #333
          .el-checkbox__inner
            width 0.345rem
            height 0.345rem
            border 1px solid #999
            &::after
              width 0.10666rem
              height 0.213333rem
              top 0.013333rem
              left 0.088333rem
    .el-input 
      .el-input__inner
        height auto
        line-height normal
        border 0
        border-radius 0
      .el-input__prefix
        .el-input__inner
          padding-left 0.6rem
        .el-input__icon
          margin-left 0.16rem
  .SubstitutionCar
    .container
      width 100%
      text-align center
      margin-top 26px
      margin-bottom -26px
      .container-top
          color #fff
          padding 160px 0
          background-image url(../images/substitutioncar.jpg)
          background-repeat no-repeat
          background-size cover
          position relative
          background-position-x center
          .container-bg
            width 100%
            height 100%
            position absolute
            top 0
            left 0
            z-index 2
            background rgba(0,0,0,0.63)
            display flex
            flex-direction column
            justify-content center
            h3
              font-family sans-serif
              font-size 46px
              font-weight 600
              padding-bottom 20px
              em
                display inline-block
                margin 0 20px
      .container-bottom
        width 80%
        height auto
        margin 0 auto
        position relative
        top -100px
        left 0
        z-index 99
        border-radius 4px
        box-shadow 3px 3px 6px rgba(0,0,0,0.63)
        background #fff
        padding 20px 0
        h4
          font-size 18px
          font-weight 600
          padding 20px 0 10px
        p
          font-size 14px
          margin 30px 0
          // &:nth-last-of-type(1),
          // &:nth-last-of-type(2),
          // &:nth-last-of-type(3)
          //   margin 8px 0
          .el-form-item
            width 47%
            margin-bottom 0
            display inline-block
            position relative
            text-align left
            .el-input
              width 98%
              height 36px
              line-height 36px
              border 1px solid #999
              border-radius 2px 
              padding-left 6px
          .cc
            visibility hidden
          span 
            width 50%
            margin-right 2px
            b
              color red
          input
            &[type="text"]
              width 50%
              height 26px
              border 1px solid #999
              border-radius 2px 
              padding-left 6px
          em
            width 50%
            height 26px
            line-height 26px
            display inline-block
            text-align left 
            font-style normal
            label
              display block
              cursor pointer
              input[type="checkbox"]
                margin-right 3px
        .button
          padding 20px 0
          margin 0
          input[type="button"]
            font-size 18px
            color #fff
            width 200px
            height 36px
            background #d81240
            cursor pointer
  @media screen and (min-width: 460px) and (max-width: 620px) 
    .SubstitutionCar .container 
      .container-bottom
        width 90%
        p .el-form-item
          width 60%
      .container-top .container-bg h3
        font-size 40px
  @media screen and (min-width: 100px) and (max-width: 459px) 
    .SubstitutionCar .container 
      .container-bottom
        width 94%
        p .el-form-item
          width 68%
      .container-top .container-bg h3
        font-size 34px
</style>



// WEBPACK FOOTER //
// src/pages/SubstitutionCar.vue